import {
  // eslint-disable-next-line no-unused-vars
  TweenLite,
} from 'gsap';

import { debounce } from 'lodash';

import ScrollToPlugin from 'gsap/ScrollToPlugin';
// eslint-disable-next-line no-unused-vars
const plugins = [ScrollToPlugin];

const getScrollPercent = () => {
  const h = document.documentElement;
  const b = document.body;
  const st = 'scrollTop';
  const sh = 'scrollHeight';
  return ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
};

document.addEventListener('DOMContentLoaded', () => {
  const secondaryNavLinks = document.querySelectorAll('.secondaryNav-list li a');

  if (window.location.hash) {
    const section = document.getElementsByName(window.location.hash.substring(1));
    if (section.length !== 0) {
      TweenLite.to(window, 0.6, { scrollTo: { y: section, offsetY: 200 } });
    }
  }

  if (document.getElementsByClassName('secondaryNav-container--pages').length === 0) {
    Array.from(secondaryNavLinks).forEach(element => {
      element.addEventListener('click', event => {
        event.preventDefault();
        const linkName = event.target.getAttribute('href');
        const section = document.getElementsByName(linkName.substring(1))[0];
        window.location.hash = linkName;
        TweenLite.to(window, 0.6, { scrollTo: { y: section, offsetY: 200 } });
      });
    });
  }
});

let position = document.documentElement.scrollTop;
const masthead = document.getElementById('masthead');
const primaryNavHeight = document.getElementById('primaryNav').clientHeight;

if (document.getElementById('secondaryNav') != null) {
  document.addEventListener(
    'scroll',
    debounce(() => {
      const scroll = document.documentElement.scrollTop;
      if (scroll > position) {
        const verticalScroll = getScrollPercent();
        if (verticalScroll > 10) {
          TweenLite.to(masthead, 0.3, { y: `-${primaryNavHeight}` });
        }
      } else {
        TweenLite.to(masthead, 0.3, { y: 0 });
      }

      position = scroll;
    }, 10),
  );
}
